import React from 'react';
import { Phone, Mail, MapPin, Clock, Instagram } from 'lucide-react';
import './Footer.css';
import AddressLink from './AddressLink';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="footer-logo-text">
                <span className="footer-logo-title">Oliver Bauer</span>
                <span className="footer-logo-subtitle">Sportphysiotherapie</span>
              </div>
            </div>
            <p className="footer-tagline">
              Recover with purpose. Return with confidence. Prevent with knowledge.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Kontakt</h4>
            <div className="footer-links">
              <div className="footer-item footer-address">
                <MapPin size={16} />
                <AddressLink
                  variant="inline"
                  label="Alte Bandfabrik 1, 7053 Hornstein"
                />
              </div>
              <div className="footer-item">
                <Phone size={16} />
                <a href="tel:06641510494">0664 1510494</a>
              </div>
              <div className="footer-item">
                <Mail size={16} />
                <a href="mailto:office@physiotherapie-oliverbauer.com">office@physiotherapie-oliverbauer.com</a>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Öffnungszeiten</h4>
            <div className="footer-links">
              <div className="footer-item">
                <Clock size={16} />
                <span>Samstag: 8–20 Uhr</span>
              </div>
              <div className="footer-item">
                <span style={{ marginLeft: '24px' }}>Weitere Termine nach Vereinbarung</span>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-heading">Folgen Sie mir</h4>
            <div className="footer-social">
              <a href="https://instagram.com/physio.bauer?igsh=dG5rd3VrNHIxN2k4" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-legal">
            <a href="/impressum">Impressum</a>
            <span className="separator">|</span>
            <a href="/agb">AGB</a>
            <span className="separator">|</span>
            <a href="/agb">Datenschutz</a>
          </div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} Oliver Bauer Sportphysiotherapie. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
